import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NgxJsonViewerComponent } from 'ngx-json-viewer';

@Component({
  selector: 'sc-json-viewer',
  templateUrl: './json-viewer.component.html',
  styleUrls: ['./json-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class JsonViewerComponent {
  title: string;
  json: any;
  date: any;
  expanded = false;
  viewMode: 'tree' | 'json' = 'tree';
  dateDetailsLink: string;

  constructor() {}

  ngOnInit() {
    let isRaw = localStorage.getItem('rawJson') == '1';
    this.viewMode = isRaw ? 'json' : 'tree';
  }

  expandToggle() {
    this.expanded = !this.expanded;
  }
}
